// Fix Instagram Feed Arrows - Black Circles with White Arrows
(function() {
  function fixInstagramArrows() {
    const arrows = document.querySelectorAll('.instafeed-new-arrow, .instafeed-new-arrow-prev, .instafeed-new-arrow-next, button[aria-label*="post"]');
    
    arrows.forEach(arrow => {
      // Force black background, remove background image
      arrow.style.setProperty('background', '#000000', 'important');
      arrow.style.setProperty('background-color', '#000000', 'important');
      arrow.style.setProperty('background-image', 'none', 'important');
      arrow.style.setProperty('border-radius', '50%', 'important');
      arrow.style.setProperty('border', 'none', 'important');
      arrow.style.setProperty('box-shadow', 'none', 'important');
      
      // Fix the SVG icon color
      const svg = arrow.querySelector('svg');
      if (svg) {
        svg.style.setProperty('fill', '#ffffff', 'important');
        svg.style.setProperty('stroke', '#ffffff', 'important');
        svg.style.setProperty('color', '#ffffff', 'important');
      }
      
      // Also target paths within SVG
      const paths = arrow.querySelectorAll('svg path, svg polyline, svg line');
      paths.forEach(path => {
        path.style.setProperty('fill', '#ffffff', 'important');
        path.style.setProperty('stroke', '#ffffff', 'important');
      });
    });
  }
  
  // Apply immediately
  fixInstagramArrows();
  
  // Apply after DOM loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixInstagramArrows);
  }
  
  // Apply after window loads (after Instagram widget)
  window.addEventListener('load', function() {
    setTimeout(fixInstagramArrows, 500);
    setTimeout(fixInstagramArrows, 1000);
    setTimeout(fixInstagramArrows, 2000);
  });
  
  // Watch for Instagram widget adding arrows dynamically
  const observer = new MutationObserver(fixInstagramArrows);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

